import React from "react";
import { Redirect } from "react-router-dom";

// Created By Cursor — merged into LeaveManagement
export default function StudentLeave() {
  return <Redirect to="/AdminMain/LeaveManagement?type=student" />;
}
